import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import bannerImage from "../../Images/about/dignatory_banner.webp";
import dignitary1 from "../../Images/Hon'ble Persons/Dr. Umesh Kumar Mishra.webp";
import dignitary2 from "../../Images/Hon'ble Persons/Chief Minister Shri Vishnu Dev Sai.webp";
import quoteIcon from "../../Images/about/quotemark.webp";

const DignitariesMessage = () => {
  const messages = [
    {
      id: 1,
      name: "Shri Vishnu Dev Sai",
      designation: "Hon'ble Chief Minister of Chhattisgarh",
      image: dignitary2,
      message: `Hon'ble Shri Vishnu Deo Sai Ji is an Indian politician currently serving as the Chief Minister of Chhattisgarh. He is the first senior tribal leader in Central India. Shri Vishnu Deo Sai Ji is the member of Bharatiya Janata Party (BJP) and Rashtriya Swayamsevak Sangh (RSS). He currently represents Kunkuri in Chhattisgarh Legislative Assembly. Shri Vishnu Deo Sai Ji is known for his decisive approach in addressing public welfare issues. His dedication extends beyond Chhattisgarh, as he has actively engaged with tribal concerns in states including Madhya Pradesh, Odisha, Telangana, and Maharashtra. Beyond politics, Shri Vishnu Deo Sai Ji has actively engaged in social work, particularly focused on tribal education and the development of essential infrastructure in tribal regions. He has been a consistent advocate for improving the living standards of backward tribes, reflecting a deep-rooted commitment to social welfare.`,
    },
    {
      id: 2,
      name: "Dr. Umesh Kumar Mishra",
      designation: "Chhattisgarh Niji Vishwavidyalaya Niyamak Aayog",
      image: dignitary1,
      message: `Chhattisgarh Private Regulatory Commission, a statutory body of the Govt. of Chhattisgarh. It is responsible for providing guidance and supervision to the private Universities Established in the State of Chhattisgarh. The commission is dedicated to monitoring and supervising the academic standard of private Universities. The commission functions under the general control of the Visitor i.e. the Hon'ble Governor of Chhattisgarh. It consists of Chairman, Member Academic, and Member Administration. The Secretary looks after the functional aspect of the commission. The commission provides a regulatory mechanism in order to ensure appropriate standards in teaching, examination, research, protecting the interest of the student, and providing reasonable service conditions to the employees working in private Universities.`,
    },
  ];

  return (
    <React.Fragment>
      <title>Leadership Vision: Messages from ISBM University Dignitaries</title>
      <meta
        name="description"
        content="Read messages from ISBM University's esteemed dignitaries and key executives. Gain clear insight into the core values and guiding vision of our mission."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Messages from Dignitaries</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Dignitaries
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      {/* Messages Section */}
      <section className="ptb-50">
        <div classname="container-xxl">
          <Row className="justify-content-center">
            <Col lg={10} className="text-center">
              <img src={quoteIcon} alt="Quote" width="60" className="mb-4" />
              <h2 className="section-title modern-title text-blue">
                Guiding Words from Our Leaders
              </h2>
              <p className="lead">
                At our university, we are privileged to receive guidance and
                support from distinguished leaders who shape the educational
                landscape of Chhattisgarh. Their messages reflect our shared
                commitment to academic excellence, innovation, and social
                responsibility.
              </p>
            </Col>
          </Row>
        </div>
      </section>

      {/* Messages Section */}
      <section className="dignitaries-messages-section ptb-50 bg-light">
        <div classname="container-xxl">
          <Row className="g-4 justify-content-center m-0">
            {messages.map((dignitary) => (
              <Col lg={10} key={dignitary.id}>
                <Card className="border-0 shadow-lg dignitary-card">
                  <Row className="">
                    <Col md={4} className="dignitary-image-col">
                      <div className="dignitary-image-container position-relative h-100">
                        <img
                          src={dignitary.image}
                          alt={dignitary.name}
                          className="img-fluid"
                          style={{ objectFit: "cover" }}
                        />
                        <div className="dignitary-overlay d-flex flex-column justify-content-end">
                          <div className="overlay-content p-4">
                            <h3 className="text-white mb-2">
                              {dignitary.name}
                            </h3>
                            <p className="text-light mb-0">
                              {dignitary.designation}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={8}>
                      <Card.Body className="p-4 p-lg-5">
                        <div className="dignitary-quote-mark mb-3">
                          <img src={quoteIcon} alt="Quote" width="40" />
                        </div>
                        <Card.Text >
                          {dignitary.message}
                        </Card.Text>
                        <div className="dignitary-signature mt-4 pt-3 border-top">
                          <p className="text-muted mb-1">With warm regards,</p>
                          <h5 className="text-blue mb-0">
                            {dignitary.name}
                          </h5>
                          <p className="text-muted small">
                            {dignitary.designation}
                          </p>
                        </div>
                      </Card.Body>
                    </Col>
                  </Row>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      {/* Closing Section */}
      <section className="ptb-50">
        <div classname="container-xxl">
          <Row className="justify-content-center">
            <Col lg={8} className="text-center">
              <h3 className="section-title modern-title text-blue">
                Inspired by Leadership
              </h3>
              <p className="lead">
                These messages from our esteemed dignitaries serve as beacons
                that guide our institution's journey toward academic excellence
                and social impact. We are committed to upholding the values and
                vision shared by these leaders as we shape the future of
                education in Chhattisgarh.
              </p>
            </Col>
          </Row>
        </div>
      </section>

      <Footer />
    </React.Fragment>
  );
};

export default DignitariesMessage;
